module.exports = __webpack_public_path__ + "static/media/bringForwards.e758a8d8.svg";